import { store } from "../store";
import { call, put, takeLatest } from "redux-saga/effects";

import {
  COMPANY_TYPE_REQUEST,
  EXPERIENCED_AS_IN_TYPE_REQUEST,
  LOGIN_USER_REQUEST,
  LOGOUT_USER_DETAILS_REQUEST,
  RESEND_OTP_REQUEST,
  SAVE_USER_DETAILS_REQUEST,
  SET_NEW_PASSWORD_REQUEST,
  VERIFY_OTP_REQUEST,
  VERIFY_USER_REQUEST,
} from "./login.type";
import ENV from "../config/env";
import {
  loginSuccess,
  logoutUserSuccess,
  saveUserSuccess,
  setNewPasswordSuccess,
} from "./login.action";
import axiosInstance from "../../api/axiosInstance";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}
function getAuthHeaders() {
  const token = store.getState()?.auth?.accessToken;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}
function* verifyUserSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/dedupe/MobileOrEmail/AndSendOTP?emailOrMobile=${user}`
      // getAuthHeaders()
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* resendOtpSaga(action) {
  const {
    payload: { user },
    callback,
  } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.MESSAGING_SERVICE_URL}/resend/Otp?contact=${user}&templateCode=OTP_REGISTRATION`,
      {}
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* verifyOtpSaga(action) {
  const {
    payload: { user, otp },
    callback,
  } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.MESSAGING_SERVICE_URL}/verify/Otp?contact=${user}&otp=${otp}`,
      {}
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* saveUserSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/add/User`,
      payload
    );
    yield put(saveUserSuccess(data));
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getExprienceAsInSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/ExperienceAsDropdown`,
      {}
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}
function* getCompanyTypeSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.COMMAN_SERVICES_URL}/get/CompanyTypeDropdown`,
      {}
    );

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* loginUserSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/login`,
      payload
    );

    yield put(loginSuccess(data));

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* setNewPasswordSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/set/NewPassword`,
      payload
    );

    yield put(setNewPasswordSuccess(data));

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* logoutSaga(action) {
  const { payload, callback } = action;

  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.API_BASE_URL}${ENV.USER_SERVICE_URL}/application/logout`,
      {},
      getAuthHeaders()
    );

    yield put(logoutUserSuccess(data));

    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* loginWatcherSaga() {
  yield takeLatest(VERIFY_USER_REQUEST, verifyUserSaga);
  yield takeLatest(RESEND_OTP_REQUEST, resendOtpSaga);
  yield takeLatest(VERIFY_OTP_REQUEST, verifyOtpSaga);

  yield takeLatest(SAVE_USER_DETAILS_REQUEST, saveUserSaga);
  yield takeLatest(EXPERIENCED_AS_IN_TYPE_REQUEST, getExprienceAsInSaga);
  yield takeLatest(COMPANY_TYPE_REQUEST, getCompanyTypeSaga);
  yield takeLatest(LOGIN_USER_REQUEST, loginUserSaga);
  yield takeLatest(LOGOUT_USER_DETAILS_REQUEST, logoutSaga);
  yield takeLatest(SET_NEW_PASSWORD_REQUEST, setNewPasswordSaga);
}
